export default __webpack_public_path__ + "static/media/benefit-sr.ae263e8b.png";